import type { ExtractKeyUnion } from "@vTypes/util-type.ts";
import { SubTab, SubTabItem } from "@/layouts/SubTab";

const ROSTER_TABS = [
  {
    name: "ALL",
    displayName: "전체 근무표",
    to: "/roster_view",
    end: true,
  },
  {
    name: "MY",
    displayName: "내 근무표",
    to: "/roster_view/my",
    end: true,
  },
] as const;

export type UnionRosterTabs = ExtractKeyUnion<typeof ROSTER_TABS, "name">;

export function RosterTabs() {
  return (
    <SubTab aria-label="근무표 탭">
      {ROSTER_TABS.map((tab, index) => (
        <SubTabItem
          key={tab.name}
          value={index}
          label={tab.displayName}
          to={tab.to}
          end={tab.end}
          preserveSearch
        />
      ))}
    </SubTab>
  );
}
